(function () {

    angular
        .module('smartertoolsApp')
        .config(['$stateProvider', '$urlRouterProvider', configureStateProvider]);

    function configureStateProvider($stateProvider, $urlRouterProvider) {
        // noinspection JSAnnotator
        $stateProvider
            .state('hosting',
                {
                    url: '/hosting',
                    templateUrl: '/app/my-account/hosting/hosting.html',
                    controller: 'hostedServicesController as hosting'
                })
            .state('price-quotes',
                {
                    url: '/price-quotes',
                    templateUrl: '/app/my-account/orders/price-quotes.html',
                    controller: 'ordersController as orders'
                })
            .state('downloads',
                {
                    url: '/downloads',
                    templateUrl: '/app/my-account/downloads/downloads.html',
                    controller: 'downloadsListController as downloads'
                })
            .state('invoices',
                {
                    url: '/invoices',
                    templateUrl: '/app/my-account/orders/orders.html',
                    controller: 'ordersController as orders'
                })

             .state('lease-providers',
                {
                    url: '/lease-providers',
                    templateUrl: '/app/my-account/partner-leasing/lease-providers.no-preload.html',
                    controller: 'leaseProviderController as leaseprovider'
                })
            .state('lease-pricing-table',
                {
                    url: '/lease-pricing-table',
                    templateUrl: '/app/my-account/partner-leasing/pricing-table.no-preload.html',
                    controller: 'leaseProviderController as leaseprovider'
                })
            .state('lease-activity-report',
                {
                    url: '/lease-activity-report',
                    templateUrl: '/app/my-account/partner-leasing/activity-report.no-preload.html',
                    controller: 'leaseProviderController as leaseprovider'
                })
            .state('licenses',
                {
                    url: '/licenses',
                    templateUrl: '/app/my-account/licenses/licenses.html',
                    controller: 'licenseKeyController as licenses'
                })
            .state('high-availability',
                {
                    url: '/high-availability',
                    templateUrl: '/app/my-account/high-availability/ha.html'
                })
            .state('high-availability.billing-report',
                {
                    url: '/high-availability/billing-report/{licenseId}',
                    data: { pageTitle: "Billing Report" },
                    views: {
                        "@": {
                            templateUrl: "/app/my-account/high-availability/ha-billing-report.html",
                        }
                    }
                })

            .state('resellers',
                {
                    url: '/resellers',
                    templateUrl: '/app/my-account/partner-reselling/resellers.no-preload.html',
                    controller: 'resellersController as resellers'
                })
            .state('reseller-pricing-table',
                {
                    url: '/reseller-pricing-table',
                    templateUrl: '/app/my-account/partner-reselling/reseller-pricing-table.no-preload.html',
                    controller: 'resellersController as resellers'
                })
            .state('settings',
                {
                    url: '/settings',
                    templateUrl: '/app/my-account/settings/settings.html',
                    controller: 'settingsController as settings'
                })
            .state('support',
                {
                    url: '/support',
                    templateUrl: '/app/my-account/support/support.html',
                    controller: 'supportController as support'
                })
            .state('partner-suspended',
                {
                    url: '/partner-suspended',
                    templateUrl: '/app/my-account/partner/partner-suspended.html',
                    controller: 'partnerSuspendedController as partnersuspended'
                });
        $urlRouterProvider.otherwise('/settings');
    }

})();